import React from 'react';
import { ShieldCheck, Users } from 'lucide-react';
import { SYNC_SOURCES } from '../../lib/syncHistory.js';

const OPTIONS = [
  { id: SYNC_SOURCES.MASTER, label: 'CIVIX Master Accounts (Instant)', icon: ShieldCheck },
  { id: SYNC_SOURCES.MANAGER, label: 'Team Manager / Peer Account', icon: Users },
];

/**
 * Pill selector: sync from a CIVIX Master package or from a team manager.
 * @param {{value: string, onChange: (id: string) => void}} props
 * @returns {JSX.Element}
 */
export default function SyncSourceTabs({ value, onChange }) {
  return (
    <div role="tablist" aria-label="Sync source" className="inline-flex flex-wrap gap-1 p-1 rounded-full bg-black/40 border border-white/10">
      {OPTIONS.map(({ id, label, icon: Icon }) => {
        const on = value === id;
        return (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={on}
            data-testid={`sync-source-${id}`}
            onClick={() => onChange(id)}
            className={`px-4 py-2 rounded-full text-xs font-semibold flex items-center gap-2 transition cursor-pointer ${on ? 'bg-civix-gradient text-white shadow-md shadow-civix-purple/30' : 'text-white/60 hover:text-white hover:bg-white/5'}`}
          >
            <Icon className="w-3.5 h-3.5" /> {label}
          </button>
        );
      })}
    </div>
  );
}
